import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import SVGIcon from '../helpers/icons'
import useSettingsManager from '../hooks/use-settings-manager'

function InputRadioBox (props) {
  const manager = usePortManager()
  const settingsManager = useSettingsManager()

  const item_id = props.name + props.value
  const checked = manager.getValue(props.name) == props.value

  return (
    <aside className={'input-week input-box'} data-size={props.size} data-size={'thirds'}>
      <input id={item_id} type={'radio'} name={props.name} value={props.value} checked={checked}
             onChange={() => manager.updateValue(props.name, props.value)}/>
      <label htmlFor={item_id}>
        <SVGIcon type={'calendar'} className={'input-week__icon'} fill={'#666666'}/>
        <div className={'input-box__title input-box__title--regular'}>
          {settingsManager.getInputSettings(props.name).week_string ?? 'Uge'} {props.value}
        </div>
      </label>
    </aside>
  )
}

export default observer(InputRadioBox)